import React, { ReactElement, useState } from 'react';
import classNames from 'classnames';
import messages from '../messages.json';

import styles from './BaseLendingTile.module.scss';
import { BaseTileParams, BaseTile } from './BaseTile';
import { LendingValueBadgeEnum } from '../types';

export type BaseLendingTileParams = Pick<
  BaseTileParams,
  | 'body'
  | 'onClick'
  | 'isSelected'
  | 'height'
  | 'checked'
  | 'onCheckboxToggle'
  | 'checkboxDisabled'
> & {
  statusBadge?: ReactElement | null;
  valueBadge?: ReactElement | null;
  financeSourceName?: string | null;
  financeImageUrl?: string | null;
  lendingValueBadge?: LendingValueBadgeEnum | null;
};

export function BaseLendingTile({
  statusBadge,
  valueBadge,
  body,
  financeSourceName,
  financeImageUrl,
  checked,
  onCheckboxToggle,
  onClick,
  isSelected,
  height,
  checkboxDisabled,
  lendingValueBadge,
}: BaseLendingTileParams) {
  const financeSourceText = (
    <div className={styles.financeSourceText} data-testid="finance-source-text">
      <span className={styles.from}>{messages.baseTile.from}</span>
      <span className={styles.financeSourceName}>{financeSourceName}</span>
    </div>
  );

  const [hasFinanceImageError, setHasFinanceImageError] = useState(false);

  const header = (
    <div
      className={classNames(styles.header, {
        [styles.denied]:
          lendingValueBadge === LendingValueBadgeEnum.APPLICANT_DENIED,
      })}
    >
      <div className={styles.statusBadge} data-testid="tile-status-badge">
        {statusBadge}
      </div>
      <div className={styles.valueBadge} data-testid="tile-value-badge">
        {valueBadge}
      </div>
    </div>
  );

  let footer;

  if (financeImageUrl && !hasFinanceImageError) {
    footer = (
      <div className={styles.footer}>
        <img
          data-testid="finance-img"
          alt={financeSourceName ?? undefined}
          src={financeImageUrl}
          className={styles.providerImg}
          onError={() => {
            setHasFinanceImageError(true);
          }}
        />
      </div>
    );
  } else if ((!financeImageUrl || hasFinanceImageError) && financeSourceName) {
    footer = <div className={styles.footer}>{financeSourceText}</div>;
  }

  return (
    <BaseTile
      checkboxDisabled={checkboxDisabled}
      header={header}
      body={body}
      footer={footer}
      checked={checked}
      onCheckboxToggle={onCheckboxToggle}
      onClick={onClick}
      isSelected={isSelected}
      height={height}
    />
  );
}
